import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { StyledTextField } from "../../../common/components/TextField/styles";
import { payCaseProgressSchema } from "../schema/payCaseProgressSchema";
import { payCaseProgress } from "../../../api/caseApi";
import DateInput from "../../../common/components/Input";

const PayCaseProgressDialog = ({
  openPayCaseProgress,
  handleClosePayCaseProgress,
  caseId,
  caseProgressId,
  amountDue,
  refresh,
  getPaymentTransactions,
}) => {
  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(payCaseProgressSchema),
  });
  console.log(caseProgressId);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    let defaultValues = {};
    defaultValues.caseId = caseId;
    defaultValues.caseProgressId = caseProgressId;
    defaultValues.amount = amountDue;

    reset({ ...defaultValues });
  }, [caseId, reset, caseProgressId, amountDue]);

  const submitPayCaseProgress = async (values) => {
    setIsSubmitting(true);
    await payCaseProgress(values);
    handleClosePayCaseProgress();
    refresh();
    getPaymentTransactions();
    setIsSubmitting(false);
  };
  return (
    <div>
      <StyledDialog
        open={openPayCaseProgress}
        onClose={handleClosePayCaseProgress}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Pay</DialogTitle>
        <form onSubmit={handleSubmit(submitPayCaseProgress)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={6.5}>
                <StyledTextField
                  sx={{ width: "100%" }}
                  variant="outlined"
                  label="Transaction No."
                  InputProps={{ inputProps: { step: "any" } }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.transactionNo}
                  helperText={errors.transactionNo?.message}
                  {...register("transactionNo")}
                />
              </Grid>
              <Grid item xs={6.5}>
                <StyledTextField
                  sx={{ width: "100%" }}
                  variant="outlined"
                  disabled={true}
                  label="Amount"
                  InputProps={{ inputProps: { step: "any" } }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.amount}
                  helperText={errors.amount?.message}
                  {...register("amount")}
                />
              </Grid>
              <Grid item xs={6.5}>
                <DateInput label="Date" name="date" control={control} />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleClosePayCaseProgress}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default PayCaseProgressDialog;
